import React from "react";
import LigCustomModal from "../../../assets/components/LigCustomModal";
import Classes from "./styles/style.module.css";

const LigRules = ({ show, closeHander }) => {
  const dialogContent = (
    <div className={Classes.ligModalContainer}>
      <h4 className="mb-4">قوانین لیگ قرآنی</h4>
      <div className="d-flex">
        <p className="mb-3">1. </p>
        <p className="mb-3 text-right">
          هر چالش زمان اختصاصی دارد و باید در همان زمان چالش ها را انجام دهید.
        </p>
      </div>
      <div className="d-flex">
        <p className="mb-3">2. </p>
        <p className="mb-3 text-right">
          بعضی از چالش ها به صورت عملی می باشد که باید طبق دستورالعمل آن چالش،
          عمل کنید.
        </p>
      </div>
      <div className="d-flex">
        <p className="mb-3">3. </p>
        <p className="mb-3 text-right">
          در صورتی که سوال یا مساله ای داشتید می توانید در قسمت ارتباط با
          پشتیبان آن را پیگیری نمایید
        </p>
      </div>
      <div className="my-4 text-center">
        <button className="purplebutton" onClick={closeHander}>
          قوانین را مطالعه کردم
        </button>
      </div>
    </div>
  );
  return (
    <LigCustomModal
      open={show}
      closeHandler={closeHander}
      dialogContent={dialogContent}
    />
  );
};

export default LigRules;
